import React from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch} from "react-redux";
import {updateLevelRequest} from "../../../../store/actionCreators/clubLevel";

const BuyLevelPop =(props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {level} = props;

  const buyLevel = () => {
      dispatch(updateLevelRequest({level}));
  };

  return (
      <div className={`buyLevel`}>
          <div className={`star${props.level} star`}></div>

          <div className={`clubName`}>{t(`clubLevelName.${level}`)}</div>
          <div className={`dialogConfirmBox`}>
              <button className="primary" onClick={buyLevel}>{t('button.upgrade')}</button>
          </div>
          <div className={`clubInfo`}>
            <span className={`member`}>{`${t('member')}: ${props.memberLimit}`}</span>
            <span className={`manager`}>{`${t('manager')}: ${props.managerLimit}`}</span>
            <span className={`cost`}>{`${props.cost}`}</span>
          </div>
          <div className={`expiration`}>{t('vipValidDate')}</div>
      </div>
  );
};

export default BuyLevelPop;
